module.exports = __webpack_public_path__ + "static/img/manual_ja_23.d24f9ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_23.png
// module id = 1pr6
// module chunks = 4